export const fi = {
    languages: {
        finland: "Suomi",
        sweden: "Ruotsi",
        england: "Englanti",
        germany: "Saksa",
    },
    rowStatus: {
        new: "Uusi",
        pending: "Odottaa",
        error: "Virhe",
        active: "Aktiivinen",
        null: ""
    },
    common: {
        suppliers: "Toimittajat",
        letters: "Kirjeet",
        logout: "Kirjaudu ulos",
        servicedesk: "Asiakastuki",
        tos: "Palveluehdot",
        guide: "Käyttöopas",
    },
    login: {
        username: "Käyttäjätunnus",
        password: "Salasana",
        login: "Kirjaudu sisään",
        info1: "Hae toimittajasi automaattisesti järjestelmästä tai tuo ne tiedostosta",
        info2: "Seuraa kohdistavatko toimittajasi laskut oikeaan verkkolaskuosoitteeseen",
        info3: "Informoi verkkolaskuosoitteesi muutoksista kirjeellä tai sähköpostilla",
        wrongPass: "Virheellinen käyttäjätunnus tai salasana",
        serviceDown: "Palvelu ei ole käytettävissä. Ota yhteyttä servicedesk@apixmessaging.com.",
        accountLocked: "Turvallisuussyistä tunnus lukkiutuu 5 virheellisen kirjautumisyrityksen jälkeen. Tilisi on lukittu 5 minuutiksi."

    },
    modal: {
        confirm: "OK",
        cancel: "Peru",
        confirmSendLetter: "Haluatko varmasti lähettää {count} ilmoitusta?",
        confirmSending: "Vahvista lähetys",
        remove: "Vahvista poisto",
        stop: "Pysäytä",
    },
    letters: {
        select: "Valitse kirje",
        name: "Nimi",
        remove: "Poista",
        removeAttachment: "Poista liite",
        update: "Tallenna",
        createNew: "Luo uusi",
        create: "Luo",
        downloadPDF: "Lataa PDF",
        preview: "Esikatsele",
        updated: "Tallennettu",
        subject: "Aihe",
        errorUpdating: "Tallennus epäonnistui",
        exampleSentSuccessful: "Lähetetty",
        errorSendingExample: "Lähetys epäonnistui",
        errorAdding: "Tallennus epäonnistui",
        errorRemoving: "Poisto epäonnistui",
        removeSuccessful: "Poistettu",
        addSuccessful: "Kirje luotu",
        sendTest: "Lähetä testisähköposti",
        confirmRemove: "Haluatko varmasti poistaa kirjeen {name}?",
        confirmTest: "Lähetä testisähköposti osoitteeseen {email}?",
        userAddressMissing: "Käyttäjältä puuttuu osoitetiedot. Päivitä osoitetiedot Laskumapin työkaluista.",
        selectFile: "Tuo liite (PDF)",
        attachmentInfo: "Sähköpostilla lähettäessä liite lisätään viestiin. Kirjeellä lähettäessä liitteestä muodostetaan kirje.",
        attachmentInfo2: "Viestin voi kirjoittaa eri kielillä. Teksti valitaan vastaanottajan kielen mukaan.",
        attachment: "Liite",
        exampleEmail: "Sähköpostiosoite"
    },
    supplier: {
        suppliers: "Toimittajia",
        name: "Nimi",
        add: "Lisää",
        address: "Postiosoite",
        businessId: "Y-tunnus",
        street1: "Katu 1",
        street2: "Katu 2",
        postOffice: "Postitoimisto",
        postalCode: "Postikoodi",
        countryCode: "Maa",
        email: "Sähköposti",
        print: "Kirje",
        status: "Tila",
        "active": "Aktiivisia",
        "new": "Uusia",
        "pending": "Odottavia",
        "error": "Virhetilassa",
        updatedSupplier: "Tallennettu",
        updatedSuppliers: "Toimittajia päivitetty: {count}",
        duplicates: "Toimittajia löytyi jo listasta: {count}",
        removeSuccessful: "Toimittajia poistettu: {count}",
        fetched: "Listaus päivitetty",
        confirmRemove: "Haluatko varmasti poistaa {count} toimittajaa?",
        all: "Kaikki",

        checkForm: "Tarkista lomake",
        addedSupplier: "Toimittaja lisätty",
        addedSuppliers: "Toimittajia lisätty: {count}",
        operationFailed: "Toiminto epäonnistui",
        adder: "Lisää toimittaja",
        importer: "Tuo toimittajia",
        remover: "Poista toimittajia",
        sender: "Lähetä",
        main: "Tilanne",
        cantSendAsEmail: "{name} ei voi lähettää sähköpostina",
        containsAttachment: "{name} sisältää liitteen",

        deleteSupplier: "Poista toimittaja",
        selectLetter: "-- Valitse kirje --",
        selectDeliveryMethod: "-- Valitse toimitustapa --",
        sendLetter: "Lähetä toimittajakirje",
        invoiceCount: "Laskuja",
        lettersSent: "Kirjeitä",
        lastLetterSent: "Viimeisin kirje",
        emailsSent: "Sähköposteja",
        lastEmailSent: "Viimeisin sähköposti",
        language: "Kieli",
        importSupplier: "Tuo tiedostosta",
        examples: "Lataa mallit",
        selectFile: "Valitse tiedosto",
        selectSuppliers: "Valitse toimittajia",
        selectedSuppliers: "Valittu {count} toimittajaa",
        removeSuppliers: "Poista toimittajat",
        ofWhich: ", joista",
        inError: "virheellisiä: {count}",
        invalidAddress: "(osoitetietoja tai kieli puuttuu)",
        missingEmail: "(sähköpostiosoite tai kieli on virheellinen)",
        validSuppliers: "virheettömiä: {count}",
        sending: "Lähettää",
        sent: "Lähetetty {count}/{total}",
        failedSent: "Epäonnistuneita",
        checkListing: "Tarkista listaus",

        import: "Tuo tiedostosta",
        importInstructions1: "Tuo toimittajia excel- tai csv-tiedostosta. Y-tunnuksen perusteella jo löytyvät toimittajat jätetään lisäämättä.",
        importInstructions2: "Voit myös päivittää toimittajia y-tunnuksen perusteella valittujen sarakkeiden osalta.",
        downloadExample: "Lataa tästä excel- ja csv-mallitiedostot.",
        importSuppliers: "Tuo toimittajat tiedostosta",
        errorFileType: "Tiedostotyyppi ei kelpaa",

        importFromSystem: "Tuo järjestelmästä",
        importInstructions3: "Listasta puuttuvat toimittajat haetaan järjestelmästä.",
        importInstructions4: "Prosessi saattaa viedä useita minuutteja.",
        importSuppliersFromSystem: "Tuo toimittajat järjestelmästä",
        importingFromSystem: "Hakee toimittajia",
        overwrite: "Ylikirjoita y-tunnuksen perusteella:",

        texts: {
            count: "Näytetään {from}-{to} tuloksista|{count} tulosta|Yksi tulos",
            filter: "Rajaa tuloksia:",
            filterPlaceholder: "Hae",
            limit: "Sivukoko:",
            page: "Sivu:",
            noResults: "Ei tuloksia",
            filterBy: "Hae {column}illa",
            loading: "Haetaan...",
            defaultOption: "Valitse {column}",
            columns: "Sarakkeet"
        },
        statusTexts: {
            "active": "Vastaanotettu verkkolaskuja onnistuneesti",
            "new": "Ei ole vastaanotettu verkkolaskuja",
            "pending": "Informoitu, odotetaan verkkolaskuja",
            "error": "Vastaanotettu paperilasku informoinnin jälkeen"
        }
    },
}